var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"hero-container"},[_c('div',{staticClass:"hero-bar"},[_c('div',{staticClass:"hero-bar--content"},[_c('h2',[_vm._v("Eugene Daily")]),_c('p',[_vm._v("\n          Senior Software Engineer with experience designing, building, and maintaining Developer and Cloud Platforms.\n        ")])])])])])
}]

export { render, staticRenderFns }